@let serviceProviders = $serviceProviders | async;
<!---->
@let fetchedAt = $serviceProvidersFetchedAt | async;

<mat-card>
  <mat-card-header>
    <mat-card-title>Service Providers</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    @if (!fetchedAt) {
    <div class="d-flex justify-content-center mt-4">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    }
    <!----->
    @if (fetchedAt && serviceProviders?.length) {
    <table mat-table [dataSource]="serviceProviders ?? []">
      <ng-container matColumnDef="image">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="p-1">
            <img
              [src]="element.imageUrl"
              alt="Service Provider logo"
              class="rounded-circle"
              width="50"
              height="50"
            />
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">{{element.name}}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex align-items-center">
            <div>{{ utils.getStatus(element.status) }}</div>
            <mat-icon class="ms-2 {{ utils.getStatusColor(element.status) }}">
              {{ utils.getStatusIcon(element.status) }}
            </mat-icon>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: columns;"
        (click)="onRowClicked(row.id)"
      ></tr>
    </table>
    }
    <!----->
    @if (fetchedAt && !serviceProviders?.length) {
    <div class="text-center">
      <p>No service providers</p>
    </div>
    }
  </mat-card-content>
</mat-card>
